import React, { useState, useEffect } from "react";
import Skeleton from "react-loading-skeleton";

// styles
import styles from "./styles.module.scss";

// components
import Tags from "../Tags/Tags";
import AdSection from "./AdSection";

// assets
import ArrowRightIcon from "src/assets/images/blog/ArrowRightLg.png";

const DetailSection = ({ blogData }) => {
  const [data, setData] = useState({});

  useEffect(() => {
    if (blogData) setData(blogData);
  }, [blogData]);

  return (
    <div className={styles.section__wrapper}>
      <div className={styles.left}>
        <h1 className={styles.title}>{data?.BlogTitle || <Skeleton />}</h1>
        <Tags data={data} />
        {data?.BlogDescription ? (
          <p
            className={styles.desc}
            dangerouslySetInnerHTML={{ __html: data?.BlogDescription }}
          />
        ) : (
          <Skeleton count={5} className={styles.desc} />
        )}
        <button>
          <span>Discover now</span>
          <img src={ArrowRightIcon} alt="arrow" />
        </button>
      </div>
      {/* <div className={styles.right}>
        <AdSection />
      </div> */}
    </div>
  );
};

export default DetailSection;
